import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=29331d1a&scoped=true&"
import script from "./Leads.vue?vue&type=script&lang=ts&"
export * from "./Leads.vue?vue&type=script&lang=ts&"
import style0 from "./Leads.vue?vue&type=style&index=0&id=29331d1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29331d1a",
  null
  
)

export default component.exports